<template>
    <header-middle></header-middle>
    <bread-crumb v-if="productDetail" :vector="[{fa: `فروشگاه ${productDetail.store_place_name}`, path: `/Store/${productDetail.store_place_id}`},{fa: `${productDetail.ordination_fa}`, path: `/Category/ordinant/${productDetail.ordination}/${productDetail.store_place_id}`},{fa: `${productDetail.stuff_name}`, path: `/Product/${productDetail.id}`}]"></bread-crumb>
    <div class="banner-bootom-w3-agileits">
      <div class="container">
        <product-template :productDetail="productDetail" v-if="productDetail"></product-template>
        <survay-template :stuff_id="productDetail.id" v-if="productDetail"></survay-template>
      </div>
      <related-product :ordination_id="productDetail.ordination" :item_id="productDetail.id" v-if="productDetail"></related-product>
    </div>
  <grid-template></grid-template>
  <footer-template></footer-template>
</template>

<script setup>
import HeaderMiddle from '../section/header/header.vue';
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import BreadCrumb from "../section/item/BreadCrumb.vue";
import ProductTemplate from "../section/pages/Single/product.vue";
import SurvayTemplate from "../section/pages/Single/survayTemplate.vue";
import RelatedProduct from "../section/pages/Single/related.vue";
import {ref,computed,watch} from 'vue';
import {useRoute} from 'vue-router';
let productDetail = ref();
const route = useRoute();
const product_id = computed(() => route.params.item || 1);
watch(product_id, () => {
  showProduct()
  .then(data => {
        productDetail.value = data;
    })
}, { immediate: true });
async function showProduct(){
    let request = await fetch('https://radap.ir/Backend/api/section/pages/product/get.php?id='+ product_id.value)
    let response = await request.json()
    return response;
}
showProduct()
</script>

<style>

</style>